(function () {
  function init(root) {
    if (root.__jwReady) return;
    root.__jwReady = true;
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var form = root.querySelector('form');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var steps = root.querySelectorAll('[data-option-index]');
    var gallery = root.querySelector('[data-gallery]');

    function selected() {
      var out = [];
      steps.forEach(function (s) {
        var c = s.querySelector('input:checked');
        out[parseInt(s.getAttribute('data-option-index'), 10)] = c ? c.value : null;
        var l = s.querySelector('[data-selected-label]');
        if (l && c) l.textContent = c.value;
      });
      return out;
    }
    function find(sel) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }
    function update() {
      var v = find(selected());
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Combination unavailable'; return; }
      idInput.value = v.id;
      priceEl.innerHTML = v.price;
      if (compareEl) { compareEl.innerHTML = v.compare || ''; compareEl.hidden = !v.compare; }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? atc.getAttribute('data-label-add') : atc.getAttribute('data-label-sold');
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      } catch (e) {}
      if (v.media && gallery) {
        var m = gallery.querySelector("[data-media-id='" + v.media + "']");
        if (m) m.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-option-index]')) update();
    });

    var eng = root.querySelector('[data-engraving]');
    if (eng) {
      var cnt = root.querySelector('[data-engraving-count]');
      eng.addEventListener('input', function () { cnt.textContent = eng.value.length + '/' + eng.maxLength; });
    }

    /* Delivery date: today + processing + delivery business days (Mon to Fri) */
    var eta = root.querySelector('[data-eta]');
    if (eta) {
      var etaDate = eta.querySelector('[data-eta-date]');
      var etaNote = eta.querySelector('[data-eta-note]');
      var baseNote = etaNote ? etaNote.textContent : '';
      var addonBox = root.querySelector('[data-addon]');
      var num = function (a) { return parseInt(eta.getAttribute(a), 10) || 0; };
      var calc = function () {
        var withCert = !!(addonBox && addonBox.checked);
        var days = num('data-process') + num('data-ship') + (withCert ? num('data-cert') : 0);
        var d = new Date();
        var n = 0;
        while (n < days) {
          d.setDate(d.getDate() + 1);
          var w = d.getDay();
          if (w !== 0 && w !== 6) n++;
        }
        etaDate.textContent = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
        if (etaNote) etaNote.textContent = withCert ? 'Includes extra days for your IGI certificate. May vary by pincode.' : baseNote;
        eta.hidden = false;
      };
      calc();
      if (addonBox) addonBox.addEventListener('change', calc);
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open]');
      if (opener) {
        e.preventDefault();
        var d = root.querySelector("[data-modal='" + opener.getAttribute('data-open') + "']");
        if (d && d.showModal) d.showModal();
        return;
      }
      var closer = e.target.closest('[data-close]');
      if (closer) { var dd = closer.closest('dialog'); if (dd) dd.close(); return; }
      if (e.target.matches && e.target.matches('dialog.jw-modal')) e.target.close();
    });

    /* Magnifying glass on hover (mouse only): a round lens follows the cursor */
    if (gallery) {
      var ZOOM = 2.8, SIZE = 200;
      gallery.querySelectorAll('[data-full]').forEach(function (m) {
        var lens = null;
        function make() {
          lens = document.createElement('div');
          lens.setAttribute('aria-hidden', 'true');
          lens.style.cssText = 'position:absolute;left:0;top:0;width:' + SIZE + 'px;height:' + SIZE + 'px;border-radius:50%;z-index:5;pointer-events:none;display:none;border:3px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.25),0 8px 24px rgba(0,0,0,.28);background-color:#fff;background-repeat:no-repeat;background-image:url("' + m.getAttribute('data-full') + '")';
          var h = document.createElement('div');
          h.style.cssText = 'position:absolute;left:' + (SIZE * 0.86) + 'px;top:' + (SIZE * 0.86) + 'px;width:46px;height:9px;border-radius:5px;background:#1c1b19;transform-origin:0 50%;transform:rotate(45deg);box-shadow:0 2px 6px rgba(0,0,0,.3);pointer-events:none;z-index:5;display:none';
          lens.__handle = h;
          m.appendChild(lens);
          m.appendChild(h);
          lens.__h = h;
        }
        function hide() {
          if (!lens) return;
          lens.style.display = 'none';
          lens.__h.style.display = 'none';
          m.style.cursor = '';
        }
        function move(e) {
          if (e.pointerType && e.pointerType !== 'mouse') { hide(); return; }
          if (!lens) make();
          var r = m.getBoundingClientRect();
          var x = e.clientX - r.left, y = e.clientY - r.top;
          var half = SIZE / 2;
          lens.style.display = 'block';
          lens.style.left = (x - half) + 'px';
          lens.style.top = (y - half) + 'px';
          lens.style.backgroundSize = (r.width * ZOOM) + 'px auto';
          lens.style.backgroundPosition = (-(x * ZOOM - half)) + 'px ' + (-(y * ZOOM - half)) + 'px';
          lens.__h.style.display = 'block';
          lens.__h.style.left = (x - half + SIZE * 0.86 - 4) + 'px';
          lens.__h.style.top = (y - half + SIZE * 0.86 - 4) + 'px';
          m.style.cursor = 'none';
        }
        m.style.overflow = 'visible';
        m.addEventListener('pointerenter', move);
        m.addEventListener('pointermove', move);
        m.addEventListener('pointerleave', hide);
      });
    }

    var lb = root.querySelector('[data-lightbox]');
    if (lb && gallery) {
      var lbImg = lb.querySelector('[data-lb-img]');
      var stage = lb.querySelector('[data-lb-stage]');
      var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-full]'));
      var idx = 0;
      var show = function (i) {
        idx = (i + items.length) % items.length;
        lbImg.src = items[idx].getAttribute('data-full');
        lbImg.alt = items[idx].getAttribute('data-alt') || '';
        stage.classList.remove('is-zoomed');
        stage.scrollTop = 0;
        stage.scrollLeft = 0;
      };
      gallery.addEventListener('click', function (e) {
        var m = e.target.closest('[data-full]');
        if (!m || !lb.showModal) return;
        show(items.indexOf(m));
        lb.showModal();
      });
      lb.querySelector('[data-lb-close]').addEventListener('click', function () { lb.close(); });
      lb.querySelector('[data-lb-prev]').addEventListener('click', function () { show(idx - 1); });
      lb.querySelector('[data-lb-next]').addEventListener('click', function () { show(idx + 1); });
      lbImg.addEventListener('click', function (e) {
        var r = lbImg.getBoundingClientRect();
        var rx = (e.clientX - r.left) / r.width;
        var ry = (e.clientY - r.top) / r.height;
        var zoomed = stage.classList.toggle('is-zoomed');
        if (zoomed) {
          stage.scrollLeft = rx * lbImg.offsetWidth - stage.clientWidth / 2;
          stage.scrollTop = ry * lbImg.offsetHeight - stage.clientHeight / 2;
        }
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var addon = root.querySelector('[data-addon]');
        if (!addon || !addon.checked) return;
        e.preventDefault();
        var title = root.querySelector('.jw-title').textContent.trim();
        var post = function (fd) {
          return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        };
        post(new FormData(form)).then(function (r) {
          if (!r.ok) { form.submit(); return; }
          var fd = new FormData();
          fd.append('id', addon.getAttribute('data-addon-id'));
          fd.append('quantity', '1');
          fd.append('properties[Certificate for]', title);
          return post(fd).then(function () { window.location.href = '/cart'; });
        }).catch(function () { window.location.href = '/cart'; });
      });
    }
  }
  function initAll() { document.querySelectorAll('[data-jw-section]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();